// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__5lI4B","flower":"styles_flower__ddRuP","leaf_opacity":"styles_leaf_opacity__Gabkb"};